import {
  UpdateOrderItemsInput,
  UpdateOrderItemsOutput,
} from "@redotech/redo-model/order-editing/schemas/update-order-items";

export const updateOrderSelfServe = {
  name: "updateOrderSelfServe" as const,
  input: UpdateOrderItemsInput,
  output: UpdateOrderItemsOutput,
};
